import { Configuration, PopupRequest } from "@azure/msal-browser";
import { config } from '../config';

if (!config.AZURE_CLIENT_ID) {
    console.error('Azure Client ID is missing from runtime configuration');
}

if (!config.AZURE_TENANT_ID) {
    console.error('Azure Tenant ID is missing from runtime configuration');
}

// Azure AD configuration
export const msalConfig: Configuration = {
    auth: {
        clientId: config.AZURE_CLIENT_ID,
        authority: `https://login.microsoftonline.com/${config.AZURE_TENANT_ID}`,
        redirectUri: config.REDIRECT_URI,
        postLogoutRedirectUri: config.REDIRECT_URI,
        clientCapabilities: ["CP1"], // This indicates this is a SPA
        protocolMode: "AAD"
    },
    cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: false
    },
    system: {
        windowHashTimeout: 9000,
        iframeHashTimeout: 9000,
        loadFrameTimeout: 9000,
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case 0:
                        console.error(message);
                        return;
                    case 1:
                        console.warn(message);
                        return;
                    case 2:
                        console.info(message);
                        return;
                    case 3:
                        console.debug(message);
                        return;
                    default:
                        console.log(message);
                        return;
                }
            },
            logLevel: 3
        }
    }
};

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest: PopupRequest = {
    scopes: ["User.Read", "openid", "profile"],
    prompt: "select_account",
    tokenBodyParameters: {
        grant_type: "authorization_code"
    }
};

// Add here the endpoints for MS Graph API services you would like to use.
export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
}; 